var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-auto w-full"},[_c('ner'),_c('margin',{staticClass:"mt-2"}),_c('billing',{staticClass:"mt-2"}),_c('revenue',{staticClass:"mt-2",attrs:{"mobile":true}}),(_vm.rolestnr)?_c('tnrmobile',{staticClass:"mt-2",attrs:{"mobile":true}}):_vm._e(),_c('ratemobile',{staticClass:"mt-2 mb-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }